import React from "react";
import ReactDOM from "react-dom";
import { AppStore } from "./Provider/Store";
// import AppStore from "./Test/material-ui_pickers";
// import AppStore from "./Test/react-number-format";

import "assets/scss/common.scss?v=1.1.0";
// import "bootstrap/dist/css/bootstrap.css";
// import "assets/scss/component.scss?v=1.1.0";
// import "perfect-scrollbar/css/perfect-scrollbar.css";

import "react-app-polyfill/ie11";
// import 'react-app-polyfill/stable';
import "core-js/stable";
import "regenerator-runtime/runtime";

import { Font } from "@react-pdf/renderer";

// Font.register(require("./Font/Nasu-Regular.ttf"), {
//   family: "Nasu-Regular",
// });

// Font.register(require("./Font/Nasu-Regular.ttf"), {
//   family: "Nasu-Bold",
// });

// MEMO(MTTスワップ): 受付開始前の動作確認用の入口。
// URL に ?mtt=test が付いていたら記憶しておく（?mtt=off で解除）。
// 未ログインだとログイン画面へ飛ばされてURLから消えてしまうため、
// 画面ごとではなくアプリ起動時のここで拾う必要がある。
try {
  const mttQuery = new URLSearchParams(window.location.search).get("mtt");
  // localStorage を使う。sessionStorage はブラウザのタブごとに消えてしまい、
  // タブを開き直すたびに指定し直しになるため。解除は ?mtt=off。
  if (mttQuery === "test") window.localStorage.setItem("mtt_preview", "1");
  if (mttQuery === "off") window.localStorage.removeItem("mtt_preview");
} catch (e) {
  // localStorage が使えない環境では何もしない
}

ReactDOM.render(<AppStore />, document.getElementById("root"));
